















































import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { TypeformForm } from '@/api/model/typeform/typeform-form'
import { TypeformLogicJump } from '@/api/model/typeform/typeform-logic-jump'
import { TypeformLogicJumpAction } from '@/api/model/typeform/typeform-logic-jump-action'
import LogicJumpPopOutAction from '@/views/Company/Settings/Typeform/Forms/Detail/LogicJumpPopOutAction.vue'
import { cloneDeep } from 'lodash'

@Component({
    components: {
        LogicJumpPopOutAction,
    },
})
export default class LogicJumpPopOut extends Vue {
    @Prop({ required: true }) readonly form!: TypeformForm
    @Prop({ required: true }) readonly logicJump!: TypeformLogicJump
    @Prop({ required: true, default: false }) readonly show!: boolean
    showPopOut: boolean = false
    internalLogicJump: TypeformLogicJump = null

    @Watch('show')
    onShowChanged() {
        this.showPopOut = this.show
    }

    @Watch('showPopOut')
    onShowPopOutChanged() {
        if (!this.showPopOut) {
            this.$emit('closed')
        }
    }

    @Watch('logicJump', { immediate: true })
    onLogicJumpChanged() {
        this.internalLogicJump = cloneDeep(this.logicJump)
        if (!this.internalLogicJump) {
            return
        }

        const alwaysAction = this.internalLogicJump.alwaysAction
        if (!alwaysAction) {
            const action = TypeformLogicJumpAction.fromData({
                action: 'jump',
                details: {
                    to: { type: null, value: null },
                },
                condition: {
                    op: 'always',
                    vars: [],
                },
            })

            this.internalLogicJump.actions.splice(this.internalLogicJump.actions.length, 0, action)
        }
    }

    save(closeModal: () => void): void {
        const logicJump = cloneDeep(this.internalLogicJump)

        const alwaysAction = logicJump.alwaysAction
        if (alwaysAction && alwaysAction.details.to.type === null) {
            logicJump.actions = logicJump.actions.filter(action => action.id !== alwaysAction.id)
        }

        this.$emit('save', logicJump)
        closeModal()
    }

    onAddAction() {
        const action = TypeformLogicJumpAction.fromData({
            action: 'jump',
            details: {
                to: { type: null, value: null },
            },
            condition: {
                op: null,
                vars: [
                    { type: null, value: null },
                    { type: null, value: null },
                ],
            },
        })

        this.internalLogicJump.actions.splice(-1, 0, action)
    }

    onDeleteAction(action: TypeformLogicJumpAction, actionIndex: number): void {
        this.internalLogicJump.actions.splice(actionIndex, 1)
    }
}
